import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import type { DialogProps } from 'helper/types';

const Title = () => <p className='font-body text-20 text-medium leading-24'>Sorry, something went wrong</p>;

interface BodyProps {
    errorStatus?: DialogProps['errorStatus'];
}

const Body = ({ errorStatus }: BodyProps) => (
    <div className='text-16'>
        <div className='mb-10 display-flex justify-content-center'>
            <span className='rioglyph rioglyph-truck-breakdown text-77 text-gray-light' />
        </div>
        <p className='mb-15'>For technical reasons, we couldn&apos;t complete the action you tried to perform.</p>
        <p>
            Please try again or refresh the page. If that doesn&apos;t work, please contact the Control Center support
            team.
        </p>
        <p className='mt-20 text-14 text-gray-dark'>Error type {errorStatus ?? '500'}</p>
    </div>
);

interface FooterProps {
    onConfirm: DialogProps['onConfirm'];
}

const Footer = ({ onConfirm }: FooterProps) => (
    <div className='display-flex justify-content-end gap-10'>
        <Button data-testid='error-dialog-close-button' onClick={onConfirm} bsStyle={Button.PRIMARY}>
            Close
        </Button>
    </div>
);

const ErrorDialog = ({ show, onConfirm, errorStatus }: DialogProps) => (
    <Dialog
        data-testid='error-dialog'
        show={show}
        title={<Title />}
        footer={<Footer onConfirm={onConfirm} />}
        body={<Body errorStatus={errorStatus} />}
        onClose={onConfirm}
        showCloseButton
        bsSize={Dialog.SIZE_SM}
    />
);

export default ErrorDialog;
